import { TOGGLE_SIDEBAR } from '../actions/action-types';

const initialState = {
  open: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_SIDEBAR:
      return {
        open: !state.open,
      };

    default:
      return state;
  }
};
